<template>
  <el-popover
    placement="left"
    trigger="hover"
    title="Details"
  >
    <div class="capacity-item">
      <span class="capacity-title">Total Capacity: </span>
      <span>{{total}} VSYS</span>
    </div>
    <div class="capacity-item">
      <span class="capacity-title">Current Capacity: </span>
      <span>{{current}} VSYS</span>
    </div>
    <div class="capacity-item">
      <span class="capacity-title">Current VS Total: </span>
      <span>{{formatPercent(currentPercent/100)}}</span>
    </div>
    <el-progress :stroke-width="12" :percentage="currentPercent" :color="currentPercent==100?'#FFB637':'#49CC8B'"
                 slot="reference" :show-text="false" style="width: 90px"></el-progress>
  </el-popover>
</template>

<script>
  import { formatPercent } from '@/utils/data_parse';

  export default {
    name: 'Capacity',
    props: {
      total: Number,
      current: Number,
    },
    data() {
      return {
        color: '#FF8737',
      };
    },
    methods: { formatPercent },
    computed: {
      currentPercent() {
        if (this.current && this.total) {
          const percent = Math.min(this.current / this.total, 1) * 100;
          if (percent !== 100) {
            this.color = '#00fb00';
          } else {
            this.color = '#FF8737';
          }
          return percent;
        }
        if (this.total) {
          return 0;
        }
        return 100;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .capacity {
    &-item {
      margin-top: 5px;
    }
    &-title {
      font-weight: bold;
    }
  }
</style>
